import { sizes } from '../../../../lib/viewport';
import { ScreenSize } from './types';

function only(screenSize: ScreenSize): string {
    const [minWidth, maxWidth] = sizes[screenSize];

    let queryString = '';
    if (minWidth && maxWidth) {
        queryString = `(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`;
    } else if (!minWidth && maxWidth) {
        queryString = `(max-width: ${maxWidth}px)`;
    } else if (minWidth && !maxWidth) {
        queryString = `(min-width: ${minWidth}px)`;
    }

    return `@media ${queryString}`;
}

export default only;
